export default "__VITE_ASSET__irz86Wj1__";